import { cardImageSources, type GenericCharacter } from './types'

export const genericDino: GenericCharacter = {
  id: 'generic-dino',
  enabled: true,
  order: 9,
  displayName: 'Bruno',
  icon: '🦕',
  imageSources: cardImageSources('generic-dino'),
}
